import { useCallback } from 'react';
import { type Editor } from '@tiptap/react';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { EquationIcon } from '@/icons';
import { MathInline } from '@/shared/features/rich-text';
import { Button } from '@/ui_v3/components/button';
import { openEquationEditorModal } from '../EquationEditorModal';
export const EquationButton = ({
  editor,
  className,
  maxLength
}: {
  editor: Editor | null;
  className?: string;
  /** 수식 하나의 LaTeX 원문 상한. 넘으면 편집 창의 입력 버튼이 비활성화된다. */
  maxLength?: number;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const handleInsertEquation = useCallback((latex: string) => {
    // HTML 문자열로 이어 붙이면 LaTeX 의 `"` 가 속성을 깨므로 노드로 넣는다.
    editor?.commands.insertContent({
      type: MathInline.name,
      attrs: {
        latex
      }
    });
  }, [editor]);
  const handleClickEquationButton = useCallback(async () => {
    const latex = await openEquationEditorModal({
      initialValue: '',
      maxLength
    });
    if (latex) {
      handleInsertEquation(latex);
      logger.track('build_addformula', {
        location: 'question'
      });
    }
  }, [handleInsertEquation, maxLength]);
  return <Button className={className} leftSlot={<EquationIcon size="xs" fill="#7A7B89" />} onMouseDown={e => {
    e.stopPropagation();
  }} onClick={e => {
    e.stopPropagation();
    e.preventDefault();
    void handleClickEquationButton();
  }} variant="transparent" intent={'neutral'} size="xs" data-sentry-element="Button" data-sentry-component="EquationButton" data-sentry-source-file="EquationButton.tsx">
      {t('build:build.equationModal.header')}
    </Button>;
};